import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-medico-legal',
  templateUrl: './medico-legal.component.html',
  styleUrls: ['./medico-legal.component.css']
})
export class MEDICOLegalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
